import { AfterViewInit, Directive, ElementRef, TemplateRef } from '@angular/core';
import { ContainerTemplateModel, FooterTemplateModel, HeaderTemplateModel } from '../../models';

@Directive({ selector: '[rxAutocompleteHeaderTemplate]' })
export class AutocompleteHeaderTemplateDirective {
  constructor(public template: TemplateRef<HeaderTemplateModel>) {}
}

@Directive({ selector: '[rxAutocompleteContainerTemplate]' })
export class AutocompleteContainerTemplateDirective {
  constructor(public template: TemplateRef<ContainerTemplateModel>) {}
}

@Directive({ selector: '[rxAutocompleteFooterTemplate]' })
export class AutocompleteFooterTemplateDirective {
  constructor(public template: TemplateRef<FooterTemplateModel>) {}
}

@Directive({ selector: '[rxIsEllipsisActive]' })
export class IsEllipsisActiveDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      const element = this.elementRef.nativeElement;
      const childEl = element.children[0];
      if (childEl.offsetWidth < childEl.scrollWidth) {
        element.title = childEl.innerText;
      }
    }, 500);
  }
}
